<template>
  <footer class="container py-2 d-flex flex-wrap justify-content-between">
    <span class="text-nowrap pr-3 py-1 text-secondary">{{year}} © Enable Banking Oy</span>
    <nav v-if="isShowLinks">
      <router-link
        class="pr-3 d-block d-md-inline-block py-2 text-secondary"
        :to="{name: 'privacy'}">{{$t('privacyPolicy')}}</router-link>
      <router-link
        class="pr-3 d-block d-md-inline-block py-2 text-secondary"
        :to="{name: 'terms'}">{{ $t('termsOfService') }}</router-link>
      <router-link
        v-if="false"
        class="pr-3 d-block d-md-inline-block py-2 text-secondary"
        :to="{name: 'about'}">{{ $t('aboutAndContacts') }}</router-link>
      <a href="https://api.enablebanking.com/"
        class="d-block d-md-inline-block py-2 text-secondary"
        target="_blank">Enable Banking API<span class="external-link ml-1"></span></a>
    </nav>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
  props: {
    isShowLinks: {
      type: Boolean,
      default: true
    }
  }
}
</script>
